import { createRoute, useParams } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const ContentFormPageLazy = lazy(() =>
  import('@/features/content/components/ContentFormPage').then((m) => ({
    default: () => {
      const { type } = useParams({ from: '/_authenticated/content/$type/new' });
      return m.ContentFormPage({ mode: 'create', schemaType: type });
    },
  })),
);

export const contentNewRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/content/$type/new',
  component: ContentFormPageLazy,
});
